import {
  ManualTimeEntryInput,
  StartTimerInput,
  TimeDailySlice,
  TimeEntry,
  TimeTag,
  UpdateTimeEntryInput
} from '../models/time-tracking.model';

export abstract class TimeTrackingRepository {
  abstract getEntries(): Promise<TimeEntry[]>;
  abstract getActiveEntries(): Promise<TimeEntry[]>;
  abstract getTags(): Promise<TimeTag[]>;
  abstract getActivityTagIds(activityId: number): Promise<number[]>;
  abstract resolveTag(name: string): Promise<TimeTag>;
  abstract setEntryTags(entryId: number, tagIds: number[]): Promise<void>;
  abstract startTimer(input: Required<Pick<StartTimerInput, 'activityId' | 'taskId' | 'startedAt' | 'timezone'>> & {
    note: string | null;
  }): Promise<TimeEntry>;
  abstract stopTimer(entryId: number, endedAt: string): Promise<TimeEntry>;
  abstract cancelTimer(entryId: number): Promise<void>;
  abstract createManualEntry(input: Required<Pick<ManualTimeEntryInput, 'activityId' | 'taskId' | 'startedAt' | 'endedAt' | 'timezone'>> & {
    note: string | null;
  }): Promise<TimeEntry>;
  abstract updateEntry(entryId: number, input: UpdateTimeEntryInput & {
    activityId: number | null;
    taskId: number | null;
    note: string | null;
  }): Promise<TimeEntry>;
  abstract updateEntryWithTags(entryId: number, input: UpdateTimeEntryInput & {
    activityId: number | null;
    taskId: number | null;
    note: string | null;
  }, tagIds: number[]): Promise<TimeEntry>;
  abstract deleteEntry(entryId: number): Promise<void>;
  abstract getDailySlices(from: string, to: string): Promise<TimeDailySlice[]>;
}
